import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async() => {
    const { data } = await axios.get(API_URL + `/api/highlight/SHSSB`);  
    return data;
} 
export const getBirthdays = async() => {    
    const { data } = await axios.get(API_URL + `/api/birthdays/SHSSB`);
    
    return data;
} 
export const getNews = async() => { 
    const { data } = await axios.get(API_URL + `/api/news/SHSSB`);
  
    return data;
} 
export const getNewsInner = async() => { 
    const { data } = await axios.get(API_URL + `/api/news/all/SHSSB`); 
    
    return data;
} 

export const getEvents = async() => {
    const { data } = await axios.get(API_URL + `/api/events/all/SHSSB`); 
    
    return data;
} 

export const getEventsinner = async() => {
    const { data } = await axios.get(API_URL + `/api/events/All/SHSSB`); 
    
    return data;
} 

export const getGallery = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/SHSSB`);
   
    return data;
} 

export const getGalleryInner = async() => {
    const { data } = await axios.get(API_URL + `/api/gallery/All/SHSSB`);
  
    return data;
} 

export const getSubGallery = async(id) => { 
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`); 
    
    return data;
} 

export const getNotification = async() => {
    const { data } = await axios.get(API_URL + `/api/notification/SHSSB`,getHeader());
   
    return data;
} 

export const getTopper = async() => {
    const { data } = await axios.get(API_URL + `/api/topper/SHSSB`,getHeader());
   
    return data;
} 

export const getOnlineRegistration = async() => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/SHSSB`,getHeader()); 
   
    return data;
} 
 
export const getPrincipalMessage = async() => {
    const { data } = await axios.get(API_URL + `/api/principalMessage/SHSSB`, getHeader()); 
   
    return data;
} 
 
export const getVideoGallery = async() => {
    const { data } = await axios.get(API_URL + `/api/video/all/SHSSB`, getHeader());
   
    return data;
} 
export const getReading = async() => {
    const { data } = await axios.get(API_URL + `/api/reading/all/SHSSB`, getHeader()); 
   
    return data;
} 
export const getFaculty = async() => {
    const { data } = await axios.get(API_URL + `/api/faculty/all/SHSSB`, getHeader()); 
    
    return data;
} 
 
export const postTransferCertificate = async(name,admission) => { 
    const { data } = await axios.post(API_URL + `/api/tc/SHSSB`,{name,admission},getHeader());
     
    return data;
}